import { PageTotal } from "./page-total.interface";
import { Row } from "./row.model";
import { WeekDate } from "./week-date.model";

export class Page {
    id: number;
    weekDates: WeekDate = new WeekDate();
    rows: Row[];
    pageTotals: PageTotal = new PageTotal();
}